import CreatorContent from "@/components/CreatorContent";
import CreatorHeader from "@/components/CreatorHeader";
import Paginate from "@/components/Paginate";
import { useAdContext } from "@/contexts/AdContext";
import { useHeaderContext } from "@/contexts/HeaderContext";
import { SessionContext } from "@/contexts/SessionContext";
import useCurrentUser from "@/hooks/useCurrentUser";
import clsx from "clsx";
import Head from "next/head";
import { useRouter } from "next/router";
import { useContext, useEffect } from "react";
import { Seomatic } from "react-seomatic";
import useGTM from "@/hooks/useGTM";

const ChefPage = ({ chef, recipes, pageCount, pageNumber }) => {
  const { sessionId, utmString } = useContext(SessionContext);
  const { currentUser } = useCurrentUser();
  const router = useRouter();
  const gtm = useGTM();

  useEffect(() => {
    if (!chef || !sessionId || !document) return;

    const eventData = { chefName: chef.title, chefId: chef.id };

    gtm.pushEvent("chef_page_viewed", eventData);
  }, [chef.id, sessionId, router, currentUser, utmString]);

  // Set showAds to true for this page
  const { setShowAds } = useAdContext();
  useEffect(() => setShowAds(true), []);

  // Set the header border
  const { setShowBorder } = useHeaderContext();
  useEffect(() => {
    setShowBorder(true);
    return () => setShowBorder(false);
  }, []);

  const image = chef?.image?.[0];

  const { biographyIntro, biography } = chef;

  return (
    <>
      <Seomatic Head={Head} {...chef.seomatic} />

      <div className={clsx("border-b")}>
        <CreatorHeader
          heading={chef.title}
          imageSrc={image?.url}
          biographyIntro={biographyIntro}
          biography={biography}
          links={chef.links}
        />
      </div>

      <CreatorContent recipes={recipes} />

      {pageCount > 1 && (
        <Paginate
          pageCount={pageCount}
          activePage={pageNumber}
          baseUri={`/${chef.uri}`}
        />
      )}
    </>
  );
};

export default ChefPage;
